<template>
    <v-main>
        <AppBar />
        <v-layout fill-height column>
            <v-container flex-fill fluid class="pt-0">
                <div class="py-5 " v-if="ordDetail.goodsClsfNm === '물성'">
                    <div class="fs-12 fw-500 mb-2">{{ ordDetail.ordCancelDt }}
                        <span class="fw-600 error--text ml-2" v-if="ordDetail.ordStatus == '04' || ordDetail.ordStatus == '03'">취소완료</span></div>
                    <div class="d-flex align-center justify-space-between ">
                        <div class="blueGrayDarken4--text">주문번호<span class="ml-1">{{ordDetail.ordNo}}</span></div>
                        <span class="fs-12 fw-600 error--text ml-2" v-if="ordDetail.ordStatus == '02'">취소요청</span>
                    </div>
                </div>
                <div class="py-5 " v-if="ordDetail.goodsClsfNm === '티켓'">
                    <div class="fs-12 fw-500 mb-2">{{ ordDetail.ordCancelDt }}
                        <span class="fw-600 error--text ml-2" v-if="ordDetail.ordStatus == '04' || ordDetail.ordStatus == '03'">취소완료</span></div>
                    <div class="d-flex align-center justify-space-between ">
                        <div class="blueGrayDarken4--text">주문번호<span class="ml-1">{{ordDetail.ordNo}}</span></div>
                        <span class="fs-12 fw-600 error--text ml-2" v-if="ordDetail.ordStatus == '02'">취소요청</span>
                    </div>
                </div>

                <hr class="hr" />
                <div class="py-7">
                    <div class="fs-12 secondary--text mb-2">{{ ordDetail.ordDt }}</div>
                    <div class="d-flex justify-space-between" v-if="ordDetail.goodsClsfNm === '물성'">
                        <div>
                            <div class="d-flex align-center fs-18 fw-700"><span class="badge mr-2">{{ ordDetail.goodsClsfNm }}</span>{{ordDetail.goodsNm}}</div>
                            <div class="secondary--text mt-2">{{ ordDetail.goodsDscrt }}</div>
                            <div class="fs-16 fw-700 primary--text line-height-1 mt-6">{{ ordDetail.saleAmt+'C' | comma }}</div>
                        </div>
                        <div class="image" >
                            <v-img :src="getImage('sample3.jpg')"></v-img>
                        </div>
                    </div>
                    <div class="d-flex justify-space-between" v-if="ordDetail.goodsClsfNm !== '물성'">
                        <div>
                            <div class="d-flex align-center fs-18 fw-700"><span class="badge mr-2">{{ ordDetail.goodsClsfNm }}</span>{{ordDetail.goodsNm}}</div>
                            <div class="secondary--text mt-2">{{ ordDetail.goodsDscrt }}</div>
                            <div class="fs-16 fw-700 primary--text line-height-1 mt-6">{{ ordDetail.saleAmt - ordDetail.dcAmt+'원' | comma }}</div>
                        </div>
                    </div>
                    <v-btn v-if="ordDetail.ordStatus == '04' || ordDetail.ordStatus == '03'" plain :ripple="false" height="48" width="100%" class="btn-cancel mt-6" @click="moveCancelInfoPage" >구매 취소 정보</v-btn>
                </div>
                <hr class="hr" />
                <div class="purchase-info py-7" v-if="ordDetail.goodsClsfNm === '물성'">
                    <div class="list-title">배송지 정보</div>
                    <v-divider class="my-4"></v-divider>
                    <div class="info-list mb-10">
                        <ul>
                            <li>{{ ordDetail.recipient }}</li>
                            <li>{{ ordDetail.mobileNo }}</li>
                            <li>{{ ordDetail.addressFirst }}</li>
                            <li>{{ ordDetail.addressSecond }}</li>
                        </ul>
                    </div>
                    <div class="info-list mb-10">
                        <div class="list-title">공동현관 출입방법</div>
                        <ul>
                            <li>{{ ordDetail.enterMethodCd }}</li>
                            <li>{{ ordDetail.enterMethodMemo }}</li>
                        </ul>
                    </div>
                    <div class="info-list">
                        <div class="list-title">배송시 요청사항</div>
                        <ul>
                            <li>{{ ordDetail.requestCd }}</li>
                            <li>{{ ordDetail.requestMemo }}</li>
                        </ul>
                    </div>
                </div>
                <hr class="hr" />
                <div class="py-7" v-if="ordDetail.goodsClsfNm === '물성'" >
                    <div class="list-title">결제 정보</div>
                    <v-divider class="my-4"></v-divider>
                        <div class="d-flex flex-column gap-2 mb-5">
                            <div class="d-flex justify-space-between gray200--text fw-500">결제금액</div>
                            <dl class="payment">
                                <dt>
                                    물성리워드상품
                                </dt>
                                <dd>
                                    {{ ordDetail.saleAmt + 'C' | comma}}
                                </dd>
                            </dl>
                            <dl class="payment">
                                <dt>
                                    배송비
                                </dt>
                                <dd>
                                    {{ ordDetail.deliveryAmt + '원' | comma}}
                                </dd>
                            </dl>
                        </div>
                        <div class="d-flex flex-column gap-2 mb-5">
                            <div class="d-flex justify-space-between gray200--text fw-500">할인금액 <strong class="primary--text">0원</strong></div>
                            <dl class="payment">
                                <dt>코인사용</dt>
                                <dd>{{ ordDetail.saleAmt+'C'| comma }}</dd>
                            </dl>
                        </div>
                    <div class="d-flex justify-space-between align-center fs-16">
                        <strong class="blueGrayDarken4--text">총 결제금액</strong>
                        <strong class="primary--text">{{ ordDetail.deliveryAmt + '원' | comma}}</strong>
                    </div>
                </div>
                <div class="py-7" v-if="ordDetail.goodsClsfNm === '티켓'" >
                    <div class="list-title">결제 정보</div>
                    <v-divider class="my-4"></v-divider>
                        <div class="d-flex flex-column gap-2 mb-5">
                            <div class="d-flex justify-space-between gray200--text fw-500">상품금액</div>
                            <dl class="payment">
                                <dt>
                                    티켓금액
                                </dt>
                                <dd>
                                    {{ ordDetail.saleAmt - ordDetail.dcAmt + '원' | comma}}
                                </dd>
                            </dl>
                        </div>
                        <div class="d-flex flex-column gap-2 mb-5">
                            <div class="d-flex justify-space-between gray200--text fw-500">할인금액 <strong class="primary--text">{{ ordDetail.couponDcAmt | comma }}원</strong></div>
                            <dl class="payment">
                                <dt>쿠폰할인금액</dt>
                                <dd>{{ '- '+ordDetail.couponDcAmt+'원' | comma }}</dd>
                            </dl>
                        </div>
                        <div class="d-flex justify-space-between align-center fs-16">
                            <strong class="blueGrayDarken4--text">총 결제금액</strong>
                            <strong class="primary--text">{{ ordDetail.saleAmt - ordDetail.dcAmt - ordDetail.couponDcAmt + '원' | comma }}</strong>
                        </div>
                </div>
                <hr class="hr" />
                <div class="py-5 fs-12 fw-500">
                    <span class="gray200--text">[취소 및 교환/반품안내]</span><br />
                    구매하신 티켓/물성상품의 환불 또는 교환 정책을 안내드립니다.<br /><br />

                    <span class="gray200--text">· 티켓 취소/환불</span><br />
                    1) 결제 완료 시점부터 찐한대화 진행 이전 취소 : 전액 환불<br />
                    2) 첫 번째 찐한 대화 진행 이후 취소 : 50% 환불<br />
                    3) 두 번째 찐한 대화 진행 이후 취소 : 환불 불가<br /><br />

                    <span class="gray200--text">· 물성상품 취소/환불</span><br />
                    1) 결제 완료 시점부터 상품 제작 진행 전: 전액 환불<br />
                    2) 결제 완료 시점부터 상품 제작 진행 후: 환불 불가<br />
                    ※코인은 원상복구됩니다.<br /><br />

                    · 물성상품 교환<br />
                    여행안내소 > 1:1 문의 메뉴를 통해 문의해주세요.

                </div>

            </v-container>
            <div class="footer-btns">
                <BlackBtn str="1:1 문의" @click="moveFaqPage" />
                <BlackBtn str="확인" @click="moveHistoryPage"/>
            </div>
        </v-layout>
    </v-main>
</template>
<script>
import BlackBtn from "@/components/btns/BlackBtn";
import store from '@/store'
export default {
    data: () => ({
        ordNo:null,
        ordDetail:{}
    }),
    components: {
        BlackBtn,
    },
    mounted(){
        this.orderDetail();
    },
    methods:{
        moveFaqPage(){
            this.movePage("/fo/suitcase/TIC/kakao");
        },
        async orderDetail(){
            await store.dispatch('orderDetail', this.$_payload({ordNo:this.$route.query.ordNo}))
            .then(res => {
               console.log(res);
               this.ordDetail = res.data;
            })
            .catch(error => {
                console.error(error)

            })
            .finally(() => {

            })
        },
        moveCancelInfoPage(){
            this.$router.push({name: '구매 취소 정보', query: {'ordNo': this.$route.query.ordNo}})
        },
        moveHistoryPage(){
            this.movePage("/fo/purchase/history");
        }

    },filters:{
        comma(val){
            return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },
}
</script>

<style lang="scss" scoped>
.footer-btns {
    display: flex;
    gap: 10px;
    .v-btn {
        min-width: calc(51% - 10px)!important;
    }
}
.badge {
    border: 1px solid $color-main;
    padding: 0 10px;
    height: 22px;
    font-size: 12px;
    font-weight: 500;
    color: $color-main;
    background: transparent;
    border-radius: 20px;
    width: auto;
    flex-shrink: 0;
}
.image {
        width: 80px;
        height: 80px;
        border-radius: 4px;
        overflow: hidden;
        flex-shrink: 0;
        margin-left: 12px;
    }
.btn-cancel {
    border:1px solid #E6E8EA;
}
.list-title {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 700;
    color: #212529;
    margin-bottom: 10px;
    .v-btn.btn {
        background: $color-sub;
        border-radius: 20px;
        color: $color-main;
        font-size: 12px;
        font-weight: 400;
        height: 22px;
        padding: 0 12px;
        min-width: 20px;

    }
}
.payment {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    dt {
        color: #B1B1B1;
    }
    dd {
        color: #9FA3A8;
        font-weight: 500;
    }
}
.purchase-info {
    display: flex;
    flex-direction: column;
    .info-list {
        display: flex;
        flex-direction: column;
        ul {
            display: flex;
            flex-direction: column;
            gap: 5px;
            li {
                line-height: 22px;
            }
        }
    }
}
</style>